// Admin permission keys — mirrors the backend catalog (GET /admin/permissions/catalog).
// The UI fetches the live catalog for the Super Admin's toggle screen; this list
// is the fallback if that request fails, and the source for labels everywhere else.
export const ADMIN_PERMISSIONS = [
  { key: 'cis',             label: 'CIS',              description: 'Adjust user CIS scores, CIS weights/rewards and referral rewards' },
  { key: 'platform_config', label: 'Platform config',  description: 'Platform info, maintenance mode, staking settings, season dates, anti-farming, staking fee' },
  { key: 'policies',        label: 'Policies',         description: 'Edit policies and policy categories' },
  { key: 'categories',      label: 'Categories',       description: 'Create post categories' },
  { key: 'announcements',   label: 'Announcements',    description: 'Create, edit and delete announcements' },
  { key: 'ads',             label: 'Ads',              description: 'Create ads' },
  { key: 'tasks',           label: 'Social tasks',     description: 'Manage tasks, review submissions, manual completion' },
  { key: 'seasons',         label: 'Seasons',          description: 'Reward seasons, conversion config and season leaderboard / payouts' },
  { key: 'user_management', label: 'User management',  description: 'Delete, suspend and unsuspend users' },
  { key: 'marketplace',     label: 'Marketplace',      description: 'Flag or void offerwall completions' },
]

export const PERMISSION_LABELS = Object.fromEntries(
  ADMIN_PERMISSIONS.map(p => [p.key, p.label]),
)

// Dashboard tab -> permission needed to USE that tab's actions.
// Tabs with mixed requirements (users, cpt_cis, config) are handled per-control.
export const TAB_PERMISSION = {
  season:        'seasons',
  season_payout: 'seasons',
  staking:       'platform_config',
  revenue:       'platform_config',
  offerwall:     'marketplace',
  social_tasks:  'tasks',
  ads:           'ads',
  announcements: 'announcements',
  categories:    'categories',
  policies:      'policies',
}

// Tabs where even GET requests return 403 without the permission
// (every /admin/season-leaderboard/* route is gated).
export const FULLY_GATED_TABS = new Set(['season_payout'])

export const NO_PERMISSION_MESSAGE =
  'You do not have permission for this action. Ask the super admin to grant it.'

export const isForbidden = (err) => err?.status === 403
